import { IComment } from "@mctypes/global.types";
import { IMeeting } from "@mctypes/meeting.types";
import { Card, Stack, Title } from "@mantine/core";
import React from "react";
import { FailedAlert } from "../../../../../components";
import { useAppSelector } from "../../../../../hooks";
import MultiCommentMantine from "../../../issuesApp/IssuesTab/IssueItemModal/new/MultiCommentMantine";
import { doCreateComment } from "../../../projects/restQueries";
import {
  useAddAgendaCommentMutation,
  useDeleteAgendaCommentMutation,
  useReactToAgendaCommentMutation,
  useUpdateAgendaCommentMutation,
} from "../../meetingAgendaRTK";
import { MeetingDetails } from "../../meetingApiTypes";

export const AgendaItemComments: React.FC<{
  agendaItem: IMeeting.AgendaItem;
  projectId: string;
  singleMeeting: MeetingDetails;
}> = ({ agendaItem, projectId, singleMeeting }) => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const [addComment, { isError: addError, isLoading: addLoading }] = useAddAgendaCommentMutation();
  const [deleteComment, { isError: deleteError, isLoading: deleteLoading }] = useDeleteAgendaCommentMutation();
  const [updateComment, { isError: updateError, isLoading: updateLoading }] = useUpdateAgendaCommentMutation();
  const [reactToComment, { isError: reactError }] = useReactToAgendaCommentMutation();

  const isError = addError || deleteError || updateError || reactError;
  const isLoading = addLoading || deleteLoading || updateLoading;

  const onCreateComment = async (text: string, metadata: any) => {
    const createdComment = await doCreateComment(
      project._id,
      agendaItem._id,
      "meetingAgendaItem",
      text,
      singleMeeting._id,
      metadata,
    );
    addComment({
      projectId: projectId,
      agendaId: agendaItem._id,
      commentId: createdComment._id,
    });
  };

  const onDeleteComment = (_id: string): void => {
    deleteComment({ projectId, agendaId: agendaItem._id, commentId: _id });
  };

  const onSaveComment = async (_id: string, text: string, metadata: any): Promise<void> => {
    await updateComment({ projectId, commentId: _id, text, agendaId: agendaItem._id, metadata }).unwrap();
  };

  const user = useAppSelector((state) => state.globalReducer.user);

  return (
    <Stack gap="xs">
      {isError === true && <FailedAlert />}
      <Title order={6}>Diskusjon</Title>
      <Card w="100%" bg="#f8f9fa" bd="1px solid var(--mantine-color-warmgray-2)">
        <MultiCommentMantine
          members={project?.members ?? []}
          sortDesc={false}
          alwaysShowInput={true}
          showCancelButton={false}
          useBrowserPrompt={true}
          comments={(agendaItem?.comments as IComment[]) ?? []}
          isLoading={isLoading}
          visibleCommentsOnLoad={5}
          onAdd={onCreateComment}
          onDelete={onDeleteComment}
          onUpdate={onSaveComment}
          onReact={async (commentId, emoji) => {
            await reactToComment({ projectId, agendaId: agendaItem._id, commentId, emoji });
          }}
          currentUserId={user?._id}
          loggedInUser={user}
          allowDelete={true}
        />
      </Card>
    </Stack>
  );
};
